import { useGetOne, useUpdateOne } from '@/queries/admin';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, FormData } from './Form';
import { LoadingSpinner } from '@/components/UI/Common/Admin/LoadingSpinner';
import toast from 'react-hot-toast';
import { ROUTES } from '@/config/routes';
import { PageLayout } from '@/components/UI/Layouts/Admin/PageLayout';
import { useDeleteOne } from '@/queries/admin';

export const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: applicationGroup } = useGetOne('application-groups', id!);
  const { mutateAsync: updateApplicationGroup } = useUpdateOne('application-groups');
  const { mutateAsync: deleteApplicationGroup } = useDeleteOne('application-groups');

  const [formData, setFormData] = useState<Partial<FormData> | null>(null);

  useEffect(() => {
    if (!applicationGroup) return;
    setFormData({ ...formData, ...applicationGroup });
  }, [applicationGroup]);

  const onSubmit = async (data: FormData) => {
    try {
      await updateApplicationGroup({ id: id!, data });
      toast.success('Группа успешно обновлена');
      navigate(ROUTES.ADMIN.APPLICATION_GROUPS);
    } catch (error) {
      console.error('Error updating:', error);
      toast.error('Произошла ошибка при обновлении группы');
    }
  };

  const handleDelete = async () => {
    try {
      await deleteApplicationGroup({ id: id! });
      toast.success('Группа успешно удалена');
      navigate(ROUTES.ADMIN.APPLICATION_GROUPS);
    } catch (error) {
      console.error('Error deleting:', error);
      toast.error('Произошла ошибка при удалении группы');
    }
  };

  if (!formData) return <LoadingSpinner className="mt-6" text="Загрузка..." />;

  return (
    <PageLayout
      breadcrumbs={[
        {
          label: 'Группы приложений',
          href: ROUTES.ADMIN.APPLICATION_GROUPS,
        },
        {
          label: 'Редактирование',
          href: '',
        },
      ]}
    >
      <Form onDelete={handleDelete} onSubmit={onSubmit} formData={formData} />
    </PageLayout>
  );
};
